if (!customElements.get('media-gallery')) {
  customElements.define('media-gallery', class MediaGallery extends HTMLElement {
    constructor() {
      super();

      this.elements = {
        viewer: this.querySelector('[id^="GalleryViewer"]'),
        thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
      };

      if (!this.elements.viewer || !this.elements.thumbnails) return;

      this.bindThumbnailClicks();
      this.observeDOMChanges();
    }

    bindThumbnailClicks() {
      this.elements.thumbnails.querySelectorAll('[data-target]').forEach((thumbnail) => {
        const button = thumbnail.querySelector('button');
        if (button && !button.dataset.bound) {
          button.dataset.bound = 'true';
          button.addEventListener('click', () => {
            this.activateImage(thumbnail.dataset.target);
          });
        }
      });
    }

    activateImage(mediaId) {
      const allMedia = Array.from(this.elements.viewer.querySelectorAll('[data-media-id]'));
      const allThumbs = Array.from(this.elements.thumbnails.querySelectorAll('[data-target]'));

      // 1️⃣ Doğrudan ID eşleşmesi
      let activeMedia = this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`);

      // 2️⃣ Fallback: sıra bazlı eşleşme (Flux teması bazen id'leri değiştiriyor)
      if (!activeMedia) {
        const index = allThumbs.findIndex((t) => t.dataset.target === mediaId);
        if (index > -1 && allMedia[index]) activeMedia = allMedia[index];
      }

      if (!activeMedia) return;

      // 3️⃣ Tüm görselleri pasifleştir
      allMedia.forEach((m) => {
        m.classList.remove('is-active');
        m.setAttribute('aria-hidden', 'true');
        m.style.opacity = '0';
        m.style.zIndex = '0';
      });

      // 4️⃣ Seçilen görseli aktif et
      activeMedia.classList.add('is-active');
      activeMedia.setAttribute('aria-hidden', 'false');
      activeMedia.style.opacity = '1';
      activeMedia.style.zIndex = '1';

      // Flux slider yapısında geçiş animasyonları için
      const viewerSlider = this.elements.viewer.querySelector('.slider');
      if (viewerSlider && typeof viewerSlider.scrollTo === 'function') {
        viewerSlider.scrollTo({
          left: activeMedia.offsetLeft,
          behavior: 'smooth',
        });
      }

      // 5️⃣ Thumbnail’ı işaretle
      allThumbs.forEach((t) => t.classList.remove('is-active'));
      const activeThumb = allThumbs.find((t) => t.dataset.target === mediaId);
      if (activeThumb) activeThumb.classList.add('is-active');
    }

    observeDOMChanges() {
      // Flux teması varyant değişiminde thumbnail DOM’unu yeniden oluşturur.
      const observer = new MutationObserver(() => {
        const newThumbnails = this.querySelector('[id^="GalleryThumbnails"]');
        const newViewer = this.querySelector('[id^="GalleryViewer"]');
        if (newThumbnails !== this.elements.thumbnails) {
          this.elements.thumbnails = newThumbnails;
          this.elements.viewer = newViewer;
          this.bindThumbnailClicks();
        }
      });
      observer.observe(this, { childList: true, subtree: true });
    }
  });
}

// =================== Vertical Thumbnail Slider ===================
class VerticalThumbnailSlider extends HTMLElement {
  constructor() {
    super();

    this.slider = this.querySelector('ul.slider');
    this.sliderItems = this.querySelectorAll('li.slider-slide');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');
    this.step = parseInt(this.prevButton?.dataset.step || '1', 10);
    this.sliderItemHeight = 0;

    if (!this.slider || !this.nextButton) return;

    this.init();

    this.prevButton.addEventListener('click', this.scrollUp.bind(this));
    this.nextButton.addEventListener('click', this.scrollDown.bind(this));
    this.slider.addEventListener('scroll', this.updateButtons.bind(this));

    const resizeObserver = new ResizeObserver(() => this.init());
    resizeObserver.observe(this.slider);
  }

  init() {
    this.sliderItems = this.querySelectorAll('li.slider-slide');
    if (this.sliderItems.length < 2) return;
    this.sliderItemHeight = this.sliderItems[1].offsetTop - this.sliderItems[0].offsetTop;
    this.updateButtons();
  }

  scrollUp(e) {
    e.preventDefault();
    this.slider.scrollBy({ top: -this.step * this.sliderItemHeight, behavior: 'smooth' });
  }

  scrollDown(e) {
    e.preventDefault();
    this.slider.scrollBy({ top: this.step * this.sliderItemHeight, behavior: 'smooth' });
  }

  updateButtons() {
    if (!this.slider) return;
    const scrollTop = this.slider.scrollTop;
    const maxScrollTop = this.slider.scrollHeight - this.slider.clientHeight;
    this.prevButton.style.display = scrollTop <= 0 ? 'none' : 'flex';
    this.nextButton.style.display = scrollTop >= maxScrollTop - 1 ? 'none' : 'flex';
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.scrollTop + this.slider.clientHeight - offset;
    return (
      element.offsetTop + element.clientHeight <= lastVisibleSlide &&
      element.offsetTop >= this.slider.scrollTop
    );
  }
}

customElements.define('vertical-thumbnail-slider', VerticalThumbnailSlider);
